import * as api from "services/api";
import { getErrors } from "helpers/error";

export const CREATE_CONTRACT_TEMPLATE =
	"[CREATE_CONTRACT_TEMPLATE] CREATE_CONTRACT_TEMPLATE";
export const CREATE_CONTRACT_TEMPLATE_ERROR =
	"[CREATE_CONTRACT_TEMPLATE] CREATE_CONTRACT_TEMPLATE_ERROR";
export const CREATE_CONTRACT_TEMPLATE_SUCCESS =
	"[CREATE_CONTRACT_TEMPLATE] CREATE_CONTRACT_TEMPLATE_SUCCESS";

export const UPLOAD_CONTRACT_TEMPLATE_ICON =
	"[CREATE_CONTRACT_TEMPLATE] UPLOAD_CONTRACT_TEMPLATE_ICON";
export const UPLOAD_CONTRACT_TEMPLATE_ICON_ERROR =
	"[CREATE_CONTRACT_TEMPLATE] UPLOAD_CONTRACT_TEMPLATE_ICON_ERROR";
export const UPLOAD_CONTRACT_TEMPLATE_ICON_SUCCESS =
	"[CREATE_CONTRACT_TEMPLATE] UPLOAD_CONTRACT_TEMPLATE_ICON_SUCCESS";

export const SET_VALUE = "[CREATE_CONTRACT_TEMPLATE] SET_VALUE";
export const CLEAR_VALUES = "[CREATE_CONTRACT_TEMPLATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createContract(model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CREATE_CONTRACT_TEMPLATE
		});

		try {
			const { login } = getState();

			let response = await api.sendPost(`/templates/create-contract`, model, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (response.ok) {
				dispatch({
					type: CREATE_CONTRACT_TEMPLATE_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result);

				dispatch({
					type: CREATE_CONTRACT_TEMPLATE_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: CREATE_CONTRACT_TEMPLATE_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function uploadFile(id, file, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPLOAD_CONTRACT_TEMPLATE_ICON
		});

		try {
			const { login } = getState();

			if (!id) {
				id = login.user.id;
			}

			let response = await api.sendPostFile(`/templates/${id}/file`, file, {
				Authorization: "Bearer " + login.token
			});

			if (response.ok) {
				dispatch({
					type: UPLOAD_CONTRACT_TEMPLATE_ICON_SUCCESS
				});

				callback && callback();
			} else {
				let result = await response.json();
				dispatch({
					type: UPLOAD_CONTRACT_TEMPLATE_ICON_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPLOAD_CONTRACT_TEMPLATE_ICON_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
